import { Authenticationservice } from './../../services/authentication.service';
import { Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetdatafirebaseService } from '../../services/getdatafirebase.service';
import { BrdsqlService } from '../../services/brdsql.service';
import { AlertService } from 'src/app/services/alert.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-bugandgerm',
  templateUrl: './bugandgerm.component.html',
  styleUrls: ['./bugandgerm.component.css']
})
export class BugandgermComponent implements OnInit {

  // ktd
  dataSelect:any = [];
  dataInsect:any = [];
  userdata:any;
  selectyear:any;
  yearCR:string = "";
  supcode:string = '';
  plotSelect = {itid:'', landno:''};
  submitted = false;
  frm_addInsert = new UntypedFormGroup({
    yearid:new UntypedFormControl(this.yearCR,Validators.required),
    supcode: new UntypedFormControl(this.supcode ,Validators.required),
    itid:new UntypedFormControl('',Validators.required),
    disease:new UntypedFormControl('',Validators.required),
    insect:new UntypedFormControl('',Validators.required),
    pc_insect:new UntypedFormControl(0,Validators.required),
    pc_disease:new UntypedFormControl(0,Validators.required),
    Comment_1:new UntypedFormControl('',Validators.required),
  })

  constructor(
    private auth:Authenticationservice,
    private spinner:NgxSpinnerService,
    private firebase: GetdatafirebaseService,
    private brdservice: BrdsqlService,
    // private alertService: AlertService,
    ) {

    this.userdata = this.auth.Authention();
    this.selectyear = brdservice.yearID;
    this.yearCR = localStorage.getItem('yearCr');
    // this.supcode = localStorage.getItem('supcode');
    // console.log('yearCR ',this.yearCR);
    // this.firebase.getYear().then((year: any) => {this.selectyear = year.slice(4);
      // setTimeout(() => {
      //   this.selectyear;
      // }, 1500);
    // });

  }
  model:any;
  // get userForm() { return this.Enterdata.controls; }

  ngOnInit(): void {
   // this.goloadfarmerinzone();
    this.getCpSupcode();    
    this.getDatainsect();
  }

  sendData(f:any) {
    this.plotSelect.itid = f.itid;
    this.plotSelect.landno = f.landno;
    console.log('plotSelect landno :' ,this.plotSelect.landno)
  }

  // ข้อมูลโรคแมลงของ user login
 async getDatainsect() {
    this.plantbyfmlist = [];
    this.spinner.show();
    let yearid = localStorage.getItem('yearCr');
    let supcode = localStorage.getItem('supcode')
    this.brdservice.getDatainsect(yearid,supcode)
    .subscribe({
      next: (data:any) =>{        
        this.plantbyfmlist = data.recordset;
        this.plantbyfmlist.sort(function(a, b){return b.DataId - a.DataId});
        console.log('insect data: ' ,this.plantbyfmlist)
        this.spinner.hide();
        setTimeout(() => {
          $(this.table.nativeElement).DataTable();
        }, 500);
      }
    })
  }

  // โหลดข้อมูลแปลงของ นักส่งเสริม
  cpSupcode:any = [];
  getCpSupcode() {
    this.spinner.show();
    let yearid = localStorage.getItem('yearTh');
    let supcode = localStorage.getItem('supcode')
    this.brdservice.getCpsupcode(yearid,supcode)
    .subscribe({
      next: (data:any) =>{
        // console.log('cpdata ' ,data.recordset)
        this.cpSupcode = data.recordset;        
        // this.spinner.hide();
        // setTimeout(() => {
        //   $(this.table.nativeElement).DataTable();
        // }, 0);
      }
    })
  }

  // dataonefarmer:any;
  // LoadOnefarmerdata(){
  //   this.dataonefarmer = null;
  //   let year = this.Enterdata.get('yearid').value;
  //   let fmcode = ((<HTMLInputElement>document.getElementById("codefm")).value).slice(0,10)
  //   if (fmcode == '')
  //   { alert('เลือกหรือระบุรหัสชาวไร่');}
  //   else {
  //     this.spinner.show();
  //   let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_v_cp_data_w?year="+year[0]+"&fmcode="+ fmcode;
  //   axios.get(url)
  //   .then(res => {
  //     if(res.data.rowsAffected[0]==0){
  //       alert('ไม่มีข้อมูลแปลง ใน' + year[1] +' หรือลองค้นหาใหม่');
  //     }
  //     else {
  //     this.dataonefarmer = res.data.recordset;
  //     }
  //     this.spinner.hide();
  //   }).catch(err => { throw(err);})
  //   this.spinner.hide();
  //   }
  // }

  // โหลดข้อมูลชาวไร่
  famerlist:any;
  goloadfarmerinzone(){
      this.spinner.show();
      let url ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6566?supzone="+this.userdata.zonedata;
      axios.get(url)
      .then(res => {
        this.famerlist = res.data.recordset;
      }).catch(err => {console.log(err);})
      this.spinner.hide();
  }

  // storeYear() {
  //   let year = this.Enterdata.get('yearid').value
  //   console.log('year ',year)
  //   localStorage.setItem('yearCr' ,year);
  // }

  plantbyfmlist:any;
  mtable:any;
  @ViewChild('table', {static:false}) table:any;
  Loaddatatable(){;
    // this.spinner.show();
    // console.warn(this.dataInsecForm.value);
    // let year = this.Enterdata.get('yearid').value
    // console.log('year ' ,year)
    // localStorage.setItem('yearCr' ,year);
    // if  (this.mtable != undefined)
    // {this.mtable.destroy();}
    // let url ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_isDisease_insect]&w=yearid="+year+"&insect_disease_by="+this.userdata.supcode;
    // console.log('url ' ,url)
    // axios.get(url)
    //   .then(res => {
    //     if(res.data.rowsAffected[0]==0){
    //       alert('ไม่มีข้อมูลใน' + year +' หรือลองค้นหาใหม่');
    //     }
    //     else {
    //     this.plantbyfmlist = res.data.recordset;
    //     }
    //     this.spinner.hide();
    //   }).catch(err => { throw(err);})
      // setTimeout(() => {
      //   this.mtable = $(this.table.nativeElement).DataTable();
      //   // this.mydatatable.draw();
      //   }, 1500);

  }

  // บันทึกการเพิ่มข้อมูลโรคแมลง
  onSubmit(f:any){
    Swal.fire({
      title: 'ยืนยันบันทึกข้อมูล?',
      // text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยืนยัน, บันทึกข้อมูล!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.brdservice.insertInsect(f)
        .subscribe((res:any) => {
          if(res.rowsAffected[0]===1) {
            // this.getDatainsect();
            Swal.fire('Success','บันทึกข้อมูลโรค/แมลงแล้ว','success');
          } else {
            Swal.fire('!oop','เกิดความผิดพลาดบางอย่าง ข้อมูลยังไม่ถูกบันทึก','error');
          }
        })
      }
    })
  };

  // บันทึกการอัพเดต การแก้ไขปัญหา โรคแมลง
  saveUpdateInsect(f:any) {
    this.brdservice.updateInsect(f)
    .subscribe((res:any) => {
        if(res.rowsAffected[0] ===1) {
          // this.getDatainsect();
          Swal.fire('Success','บันทึกข้อมมูลการแก้ไขแล้ว','success'
          )
        };
        //  this.router.navigateByUrl('post/index');
    })
  }

  selectData(DataId:string) {
    this.dataSelect = this.plantbyfmlist.filter((el: { DataId: any; }) => el.DataId == DataId);
    this.dataSelect = this.dataSelect[0];
  }

  showAdvice(advice1:string ,advice2:string) {
    Swal.fire('คำแนะนำจากวิชาการ' ,`${advice1} / ${advice2}`,'info');
  }

}
